import { render, staticRenderFns } from "./comp_Footer-Top.vue?vue&type=template&id=1c47f24e&scoped=true&"
import script from "./comp_Footer-Top.vue?vue&type=script&lang=js&"
export * from "./comp_Footer-Top.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer-Top.vue?vue&type=style&index=0&id=1c47f24e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47f24e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
